export default {"src":"/_next/static/media/code-brackets-empty.05135fe7.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};